import { PropsWithChildren, useRef } from 'react'
import type {
  RawNonFilterParams,
  RawSearchFilters,
} from '@cinch-nx/data-search'
import {
  SearchStoreType,
  initialiseSearchStore,
} from './initialise-search-store'
import { SearchStoreContext } from './use-search-store'

export const SearchStoreProvider = ({
  children,
  params,
  isInsideStoryblok,
  allCinchStores,
  pathSegmentsFromUrl,
}: PropsWithChildren<{
  params: RawSearchFilters & RawNonFilterParams
  isInsideStoryblok: boolean
  allCinchStores: string[]
  pathSegmentsFromUrl: Partial<RawSearchFilters>
}>) => {
  const storeRef = useRef<SearchStoreType>()

  if (!storeRef.current) {
    storeRef.current = initialiseSearchStore({
      params,
      isInsideStoryblok,
      allCinchStores,
      pathSegmentsFromUrl,
    })
  }
  return (
    <SearchStoreContext.Provider value={storeRef.current}>
      {children}
    </SearchStoreContext.Provider>
  )
}
